var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "check_circle"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4332_39108",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.666504,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4332_39108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check_circle_2",
    d: "M11.228 15.9078L17.6243 9.5115L16.9165 8.80375L11.228 14.4923L8.378 11.6423L7.67025 12.35L11.228 15.9078ZM12.6698 21C11.4253 21 10.2552 20.7638 9.1595 20.2915C8.064 19.8192 7.111 19.1782 6.3005 18.3685C5.49 17.5588 4.84842 16.6067 4.37575 15.512C3.90292 14.4175 3.6665 13.2479 3.6665 12.0033C3.6665 10.7587 3.90267 9.58867 4.375 8.493C4.84734 7.3975 5.48834 6.4445 6.298 5.634C7.10767 4.8235 8.05984 4.18192 9.1545 3.70925C10.249 3.23642 11.4186 3 12.6633 3C13.9078 3 15.0778 3.23617 16.1735 3.7085C17.269 4.18083 18.222 4.82183 19.0325 5.6315C19.843 6.44117 20.4846 7.39333 20.9573 8.488C21.4301 9.5825 21.6665 10.7521 21.6665 11.9967C21.6665 13.2413 21.4303 14.4113 20.958 15.507C20.4857 16.6025 19.8447 17.5555 19.035 18.366C18.2253 19.1765 17.2732 19.8181 16.1785 20.2908C15.084 20.7636 13.9144 21 12.6698 21Z",
    fill: "#22C55E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleIcon);
export default __webpack_public_path__ + "static/media/check-circle-icon.eea269cb4729d87f854d5a0c65da527a.svg";
export { ForwardRef as ReactComponent };